import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const previewRow = (theme: ExactTheme) => css`
  padding: 7px 10px;
  border-bottom: 1px solid ${theme.colorsV2.grey[100]};
`;
